import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import ReactDOM from 'react-dom'
import { compose } from 'recompose'
import { push } from 'react-router-redux'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from 'material-ui/Dialog'

// Components
import Item from '../../../../../../components/Item'
import Loader from '../../../../../../components/Loader'

// Actions
import { loadedSavedData, removeSavedData } from './actions'

const applyUpdateResult = (result, page) => prevState => ({
  data: [...prevState.data, ...result.data],
  page: result.page,
  isError: false,
  isLoading: false
})

const applySetResult = (result, page) => prevState => ({
  data: result.data,
  page: result.page,
  isError: false,
  isLoading: false
})

const applySetError = prevState => ({
  isError: true,
  isLoading: false
})

class Results extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      page: null,
      isLoading: false,
      isError: false,
      classes: this.props.classes,
      loadedInitialData: false,
      url: ''
    }
  }

  onPaginatedSearch = e => this.fetchStories(this.state.page + 1)

  fetchStories = page => {
    this.setState({ isLoading: true })
    let myComponent = this
    console.log('load next')
    let itemsRequired = 0
    if (page > 0) {
      itemsRequired = this.state.data.length + 1
    }
    console.log(itemsRequired)

    let url = ''
    if (this.props.selected === 'clr') {
      // Color Notification
      url = `https://api.dsnapis.com/search/${
        this.props.customer_number
      }/pw/teSt1/ssrch/4/db/2/dschigh/${this.props.high_dsc}/dsclow/0/agehigh/${
        this.props.age_high
      }/agelow/${this.props.age_low}/oarhigh/${this.props.oar_high}/oarlow/${
        this.props.oar_low
      }/herprefage/${this.props.pref_age}/herprefans/${
        this.props.pref_fans
      }/clrhigh/${this.props.high_clr}/clrlow/${
        this.props.high_clr
      }/education/${this.props.education}/income/${
        this.props.income
      }/offset/${itemsRequired}/fetch/100`
    } else if (this.props.selected === 'dsc') {
      // Dating Status Code
      url = `https://api.dsnapis.com/search/${
        this.props.customer_number
      }/pw/teSt1/ssrch/4/db/2/dschigh/${this.props.high_dsc}/dsclow/${
        this.props.high_dsc
      }/agehigh/${this.props.age_high}/agelow/${this.props.age_low}/oarhigh/${
        this.props.oar_high
      }/oarlow/${this.props.oar_low}/herprefage/${
        this.props.pref_age
      }/herprefans/${this.props.pref_fans}/clrhigh/${
        this.props.high_clr
      }/clrlow/1/education/${this.props.education}/income/${
        this.props.income
      }/offset/${itemsRequired}/fetch/100`
    } else if (this.props.selected === 'none') {
      // No Sub Filter
      url = `https://api.dsnapis.com/search/${
        this.props.customer_number
      }/pw/teSt1/ssrch/4/db/2/dschigh/${this.props.high_dsc}/dsclow/0/agehigh/${
        this.props.age_high
      }/agelow/${this.props.age_low}/oarhigh/${this.props.oar_high}/oarlow/${
        this.props.oar_low
      }/herprefage/${this.props.pref_age}/herprefans/${
        this.props.pref_fans
      }/clrhigh/${this.props.high_clr}/clrlow/1/education/${
        this.props.education
      }/income/${this.props.income}/offset/${itemsRequired}/fetch/100`
    } else {
      this.props.changeRoute('/console/search/all_candidates')
    }
    //alert(url)

    axios.get(url).then(function(response) {
      //alert(JSON.stringify(response.data))
      if (Array.isArray(response.data)) {
        if (response.data.length == 0) {
          if (myComponent.state.data.length == 0) {
            alert(
              'No Results. Tap Ok to be taken back to the All Candidates section.'
            )
            myComponent.props.changeRoute('/console/search/all_candidates')
          }
        } else {
          response.page = page
          myComponent.onSetResult(response, page)
          myComponent.props.loadedSavedData(myComponent.state.data)
          myComponent.setState(
            {
              loadedInitialData: true
            },
            function() {
              window.scrollTo(0, 0)
            }
          )
        }
      } else {
        myComponent.fetchStories(page)
      }
    })
  }

  onSetResult = (result, page) =>
    page === 0
      ? this.setState(applySetResult(result, page))
      : this.setState(applyUpdateResult(result, page))

  onSetError = () => this.setState(applySetError)

  componentDidMount() {
    /*
      alert(this.props.oar_low);
      alert(this.props.oar_high);
      alert(this.props.age_high)
      alert(this.props.age_low);
      alert(this.props.pref_age);
      alert(this.props.high_dsc);
      alert(this.props.high_clr);
      alert(this.props.education);
      alert(this.props.income)
    */

    if (this.props.selected === 'clr') {
      this.fetchStories(0)
    } else if (this.props.selected === 'dsc') {
      this.fetchStories(0)
    } else if (this.props.selected === 'none') {
      this.fetchStories(0)
    } else {
      this.props.changeRoute('/console/search/all_candidates')
    }
    window.scrollTo(0, 0)
  }

  componentWillUnmount() {
    this.props.removeSavedData()
  }

  render() {
    const { classes } = this.props
    return (
      <div>
        <div className={classes.items}>
          <AdvancedList
            list={this.state.data}
            isError={this.state.isError}
            isLoading={this.state.isLoading}
            page={this.state.page}
            onPaginatedSearch={this.onPaginatedSearch}
          />
        </div>
        <div>{!this.state.loadedInitialData && <Loader />}</div>
      </div>
    )
  }
}

const List = ({ list }) => (
  <div className="list">
    {list.map(item => (
      <div className="list-row" key={item['access id']}>
        <Item data={item} />
      </div>
    ))}
  </div>
)

const withLoading = conditionFn => Component => props => {
  return (
    <div>
      <Component {...props} />
      <div>
        {conditionFn(props) && <Typography>Loading candidates...</Typography>}
      </div>
    </div>
  )
}

const withPaginated = conditionFn => Component => props => (
  <div>
    <Component {...props} />

    <div className="interactions">
      {conditionFn(props) && (
        <div>
          <div>Something went wrong...</div>
          <button type="button" onClick={props.onPaginatedSearch}>
            Try Again
          </button>
        </div>
      )}
    </div>
  </div>
)

const withInfiniteScroll = conditionFn => Component =>
  class WithInfiniteScroll extends React.Component {
    componentDidMount() {
      window.addEventListener('scroll', this.onScroll, false)
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll, false)
    }

    onScroll = () => conditionFn(this.props) && this.props.onPaginatedSearch()

    render() {
      return <Component {...this.props} />
    }
  }

const paginatedCondition = props =>
  props.page !== null && !props.isLoading && props.isError

const infiniteScrollCondition = props =>
  window.innerHeight + window.scrollY >= document.body.offsetHeight - 7000 &&
  props.list.length &&
  !props.isLoading &&
  !props.isError

const loadingCondition = props => props.isLoading

const AdvancedList = compose(
  withPaginated(paginatedCondition),
  withInfiniteScroll(infiniteScrollCondition),
  withLoading(loadingCondition)
)(List)

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    oar_low: state.saved_search_filters.oar_low,
    oar_high: state.saved_search_filters.oar_high,
    age_low: state.saved_search_filters.age_low,
    age_high: state.saved_search_filters.age_high,
    pref_age: state.saved_search_filters.pref_age,
    high_dsc: state.saved_search_filters.dsc,
    high_clr: state.saved_search_filters.clr,
    selected: state.saved_search_filters.selected_filter,
    education: state.saved_search_filters.education,
    income: state.saved_search_filters.income,
    pref_fans: state.saved_search_filters.pref_fans
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url)),
    loadedSavedData: data => dispatch(loadedSavedData(data)),
    removeSavedData: () => dispatch(removeSavedData())
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(Results)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/AllCandidates/scenes/Results/index.js